import { Controller } from "@hotwired/stimulus"
import { debugLog, isMobileDevice } from "../utils";

export default class extends Controller {
  static targets = ["backdrop", "content", "container", "scrollIndicator"];


  static values = {
    closeModalDeltaY: { type: Number, default: 100 },
    redirectUrl: { type: String, default: "" },
  }

  connect() {
    debugLog("ModalController: Connected");

    if (isMobileDevice()) {
      this.setupScrollToClose();

      if (this.hasScrollIndicatorTarget) {
        this.scrollIndicatorTarget.classList.remove("hidden");
      }
    }
  }

  disconnect() {
    this.removeScrollToClose();
  }

  setupScrollToClose() {
    if (!this.hasContainerTarget && !this.hasContentTarget) {
      return;
    }
    // Only add scroll-to-close for mobile devices
    this.touchStartY = 0;
    this.touchStartTime = 0;
    this.isScrolling = false;
    
    // Add touch event listeners to backdrop, container, and content
    const elements = [this.containerTarget, this.contentTarget];
    
    elements.forEach(element => {
      if (element) {
        element.addEventListener('touchstart', this.handleTouchStart.bind(this), { passive: true });
        element.addEventListener('touchmove', this.handleTouchMove.bind(this), { passive: true });
        element.addEventListener('touchend', this.handleTouchEnd.bind(this), { passive: true });
      }
    });
  }

  removeScrollToClose() {
    if (!this.hasContainerTarget && !this.hasContentTarget) {
      return;
    }

    const elements = [this.containerTarget, this.contentTarget];
    
    elements.forEach(element => {
      if (element) {
        element.removeEventListener('touchstart', this.handleTouchStart.bind(this));
        element.removeEventListener('touchmove', this.handleTouchMove.bind(this));
        element.removeEventListener('touchend', this.handleTouchEnd.bind(this));
      }
    });
  }

  handleTouchStart(event) {
    this.touchStartY = event.touches[0].clientY;
    this.touchStartTime = Date.now();
    this.isScrolling = false;
    this.touchTarget = event.target;
  }

  handleTouchMove(event) {
    if (!this.touchStartY) return;
    
    const currentY = event.touches[0].clientY;
    const deltaY = currentY - this.touchStartY;
    
    // If scrolling down more than 50px, mark as scrolling
    if (deltaY > 50) {
      this.isScrolling = true;
    }

    if (deltaY > this.closeModalDeltaYValue) {
      this.contentTarget.style.top = "20px"
    }
  }

  handleTouchEnd(event) {
    if (!this.touchStartY) return;
    
    const touchEndTime = Date.now();
    const touchDuration = touchEndTime - this.touchStartTime;
    const currentY = event.changedTouches[0].clientY;
    const deltaY = currentY - this.touchStartY;

    // Close modal if:
    // 1. Scrolled down more than 100px
    // 2. Touch duration is greater than 250ms, preventing accidental close
    if (this.isScrolling && deltaY > this.closeModalDeltaYValue && touchDuration > 250) {
      this.closeModal();
    }
    
    // Reset values
    this.touchStartY = 0;
    this.touchStartTime = 0;
    this.isScrolling = false;
    this.touchTarget = null;
    this.contentTarget.style.top = "0px"
  }

  closeModal() {
    if (this.redirectUrlValue) {
      Turbo.visit(this.redirectUrlValue);
      return
    }

    // Close modal will make the modal container hidden and inert
    if (this.hasContainerTarget) {
      this.containerTarget.setAttribute("inert", "");
      this.containerTarget.setAttribute("aria-hidden", "true");
      this.containerTarget.classList.add("hidden");
    }
  }
}
